import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class PageIntro extends AbstractComponent {
  init() {
    const setActive = () => {
      this.el.classList.add('is-active');
    };

    const setInactive = () => {
      this.el.classList.remove('is-active');
    };

    gsap.to(window, {
      ease: 'none',
      scrollTrigger: {
        trigger: this.el,
        start: 'top center',
        markers: false,
        end: `bottom center`,
        toggleActions: 'play none none reverse',
        onEnter: () => setActive(),
        onEnterBack: () => setActive(),
        onLeave: () => setInactive(),
        onLeaveBack: () => setInactive(),
      },
    });
  }
}

register('page-intro', PageIntro);
